import React from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { VisibilityOffOutlined, VisibilityOutlined } from '@material-ui/icons';
import makeStyles from '@material-ui/core/styles/makeStyles';
const styles = makeStyles({
    root: {
        marginBottom: '0px',
        marginTop: '0px',
    },
});
const Input = ({ type = 'text', id = '', label = '', name = '', handleChange = () => { }, handleBlur = () => { }, showPass = false, classVisible = {}, error = false, errorMessage = '', disabled = false, defaultValue = null, className = '', value = null, variant = 'outlined', }) => {
    const [showPassVisibility, setPassVisibility] = React.useState(false);
    // OTHER
    const classes = styles();
    const valueProps = value || value === '' ? { value } : {};
    const defValueProps = defaultValue || defaultValue === '' ? { defaultValue } : {};
    const inputType = showPass && showPassVisibility ? 'text' : 'password';
    return (<>
      <TextField classes={{
            root: classes.root,
        }} className={className} variant={variant} margin="normal" size="small" fullWidth type={showPass ? inputType : type} id={id} label={label} name={name} onChange={(e) => {
            // [NOTE] REACT <= 16 EVENT POOLING https://reactjs.org/docs/legacy-event-pooling.html
            e.persist();
            handleChange(e);
        }} onKeyUp={handleBlur} error={error} InputProps={{
            endAdornment: showPass ? (<InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" onClick={() => setPassVisibility(!showPassVisibility)} classes={classVisible}>
                  {showPass
                    ? <VisibilityOutlined />
                    : <VisibilityOffOutlined />}
                </IconButton>
              </InputAdornment>) : null,
        }} helperText={error ? errorMessage : null} disabled={disabled} {...valueProps} {...defValueProps}/>
    </>);
};
export default Input;
